import React, { useEffect } from 'react';
import Grid from 'components/core/Grid';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { Box, Fade } from '@mui/material';
// import { GiveEarnCredits } from 'components/views/Credits/GiveEarnCredits';
import { CheckoutReservationConfirmed } from 'components/views/pages/Checkout/CheckoutStep4/components/CheckoutReservationConfirmed';
import { CheckoutImportantUpcomingDates } from 'components/views/pages/Checkout/CheckoutStep4/components/CheckoutImportantUpcomingDates';
import { useEnsureLoggedInCheckout } from 'components/views/pages/Checkout/hooks/useEnsureLoggedInCheckout';
import { CheckoutDownloadMobileApp } from 'components/views/pages/Checkout/CheckoutStep4/components/CheckoutDownloadMobileApp';
import { BookingGateWayModeIdEnum } from '@alluradirect/react';
import { CheckoutSummaryPriceDetails } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryPriceDetails';
import { useScreenWidth } from 'webHooks/useScreenWidth';
import { CheckoutSummaryFooterLastStep } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryFooterLastStep';
import { CheckoutGatewayClosedDetails } from 'components/views/pages/Checkout/CheckoutStep4/components/CheckoutGatewayClosedDetails';
import { GiveEarnCreditsTemp } from 'components/views/Credits/GiveEarnCreditsTemp';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';
import { CheckoutReservationDetails } from './components/CheckoutReservationDetails';
import { CheckoutBoxWrapper } from '../styles';

// const CommonQuestions = () => {
//   return (
//     <Grid item xs={12}>
//       <Typography variant="h5" mb={2}>
//         Answers to common questions
//       </Typography>
//       Collapse box items
//     </Grid>
//   );
// };

export const CheckoutStep4 = (props: CheckoutStepProps) => {
  const { isMd } = useScreenWidth();
  useEnsureLoggedInCheckout(props.loginState);
  // Unlock screen, payment is complete
  useEffect(() => {
    props.setIsMakingPayment(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isGatewayClosed = props.bookingData?.PROPERTY.GATEWAY_MODE.ID === BookingGateWayModeIdEnum.closed;

  return (
    <Fade in>
      <div>
        <Grid container>
          <CheckoutBoxWrapper>
            <Box>
              <CheckoutReservationConfirmed {...props} />
              <Grid item xs={12}>
                <AppDivider marginVertical={'16px'} />
              </Grid>
              <CheckoutReservationDetails {...props} />
            </Box>


            {isMd ? (
              <>
                <Grid item xs={12}>
                  <AppDivider marginVertical={'24px'} />
                </Grid>
                <CheckoutSummaryFooterLastStep bookingData={props.bookingData} />
                <Grid item xs={12}>
                </Grid>
              </>
            ) : null}
          </CheckoutBoxWrapper>


          {isMd ?
            <>
              <Grid item xs={12}>
                <AppDivider marginVertical={'16px'} borderWidth='0' />
              </Grid>
              <CheckoutBoxWrapper>
                <CheckoutSummaryPriceDetails {...props} hasBottomAppDivider={false} hasTopAppDivider={false} />
              </CheckoutBoxWrapper>
            </> : null}


          <Grid item xs={12}>
            <AppDivider marginVertical={'16px'} borderWidth='0' />
          </Grid>

          {isGatewayClosed ? (
            <>
              <CheckoutBoxWrapper>
                <CheckoutGatewayClosedDetails />
              </CheckoutBoxWrapper>
              <Grid item xs={12}>
                <AppDivider marginVertical={'16px'} borderWidth='0' />
              </Grid>
            </>
          ) : null}

          <CheckoutDownloadMobileApp />

          <Grid item xs={12}>
            <AppDivider marginVertical={'16px'} borderWidth='0' />
          </Grid>

          {!isGatewayClosed ? (
            <>
              <CheckoutBoxWrapper>
                <CheckoutImportantUpcomingDates booking={props.bookingData} />
              </CheckoutBoxWrapper>
              <Grid item xs={12}>
                <AppDivider marginVertical={'16px'} borderWidth='0' />
              </Grid>
            </>
          ) : null}

          <CheckoutBoxWrapper>
            <GiveEarnCreditsTemp />
          </CheckoutBoxWrapper>

          {/* <Grid item xs={12}>
        <AppDivider marginVertical={'24px'} />
      </Grid> */}

          {/* <Grid container spacing={2}>
        <GiveEarnCredits creditsData={undefined} userId={3} />
      </Grid> */}

          {/* <CommonQuestions /> */}
        </Grid>
      </div>
    </Fade>
  );
};
